<app-two-rows-slider>
    <div appTwoRowSliderItem 
    infinite-scroll
    [infiniteScrollDistance]="0.5"
    [infiniteScrollThrottle]="50"
    [horizontal]="true"
    [infiniteScrollContainer]="selector"
    [fromRoot]="true"
    (scrolled)="onScroll()"
    class="imagenA" *ngFor="let categoria of noticias">
        <a (click)="cambiarCategoria(categoria.id)">
            <div class="contenttextimg">
                <img src="{{categoria.image}}">
                <div class="contenttxtcarruselfoto">
                    <div class="imgtextcarrusel alturaCarrusel">
                        <p>
                            {{categoria.autor|truncate:"65"}}
                        </p>
                    </div>

                </div>
            </div>
        </a>
    </div>
</app-two-rows-slider>
